import PeptideGrey from "./3d/peptide_grey.png"
import Peptide from "./3d/peptide.gif"
import DNAGrey from "./3d/dna_grey.png"
import DNA from "./3d/dna.gif"
import EnzymeGrey from "./3d/enzyme_grey.png"
import Enzyme from "./3d/enzyme.gif"
import AntibodyGrey from "./3d/antibody_grey.png"
import Antibody from "./3d/antibody.gif"
import VectorGrey from "./3d/vector_grey.png"
import Vector from "./3d/vector.gif"

const CategoryMapping = [
  {
    id: "PEPTIDES",
    rect_x: "455.779",
    rect_y: "-210.42",
    width: "231.675",
    height: "680",
    companies: [
      "Pepticom",
      "AI protein",
      "Menten",
      "Nuritas",
      "Unnatural Products",
      "ProteinQure",
    ],
    text_x: "466.97",
    still: PeptideGrey,
    gif: Peptide,
  },
  {
    id: "DNA/RNA",
    rect_x: "687.454",
    rect_y: "-210.42",
    width: "232.209",
    height: "680",
    companies: ["Octant", "Hexagon", "Sestina", "Sherlock", "Inceptive", "Atomic"],
    text_x: "698.693",
    still: DNAGrey,
    gif: DNA,
  },
  {
    id: "ENZYMES",
    rect_x: "919.663",
    rect_y: "-210.42",
    width: "231.675",
    height: "680",
    companies: ["Aether", "Bota", "Enzymit", "Medium", "Xyme", "Ligo"],
    text_x: "930.33",
    still: EnzymeGrey,
    gif: Enzyme,
  },
  {
    id: "ANTIBODIES",
    rect_x: "1151.338",
    rect_y: "-210.42",
    width: "231.675",
    height: "680",
    companies: [
      "EVQLV",
      "BigHat",
      "Nabla",
      "1910",
      "LabGenius",
      "MAbSilico",
      "A-Alpha",
      "Chai"
    ],
    text_x: "1161.722",
    still: AntibodyGrey,
    gif: Antibody,
  },
  {
    id: "VECTORS",
    rect_x: "1383.012",
    rect_y: "-210.42",
    width: "231.675",
    height: "680",
    companies: ["Dyno", "Apertura", "Capsida", "Affina", "Replay"],
    text_x: "1393.726",
    still: VectorGrey,
    gif: Vector,
  },
]

export default CategoryMapping
